import React from 'react';

const HoverLogo = ({ ...props }) => (
  <svg
    width="147"
    height="36"
    viewBox="0 0 147 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M54.3862 19.1672H43.8167V11.0766H41.2188V29.8626H43.8167V21.647H54.3862V29.8626H56.9842V11.0766H54.3862V19.1672Z"
      fill="#333333"
    />
    <path
      d="M73.3952 10.8204C67.7783 10.8204 63.707 14.8789 63.707 20.4765C63.707 26.0742 67.7849 30.1261 73.3952 30.1261C79.0055 30.1261 83.0833 26.0676 83.0833 20.4765C83.0833 14.8854 79.012 10.8204 73.3952 10.8204ZM78.3872 25.6401C77.1178 26.9096 75.342 27.6068 73.3952 27.6068C71.4483 27.6068 69.6856 26.9096 68.4097 25.6401C67.114 24.3442 66.4037 22.509 66.4037 20.4765C66.4037 18.444 67.114 16.6022 68.4097 15.313C69.6791 14.0435 71.4483 13.3463 73.3952 13.3463C75.342 13.3463 77.1178 14.0435 78.3872 15.313C79.6829 16.6022 80.3998 18.4374 80.3998 20.4765C80.3998 22.5156 79.6829 24.3442 78.3872 25.6401Z"
      fill="#333333"
    />
    <path
      d="M96.0787 26.9026L89.2384 11.0765H86.4629L94.533 29.7113L94.5922 29.8625H97.5191L105.635 11.0765H102.932L96.0787 26.9026Z"
      fill="#333333"
    />
    <path
      d="M113.507 21.6338H123.169V19.1803H113.507V13.5432H124.899V11.0765H110.916V29.8625H125.011V27.3959H113.507V21.6338Z"
      fill="#333333"
    />
    <path
      d="M141.12 21.818C143.474 21.4562 145.882 19.9104 145.882 16.4834C145.882 14.76 145.296 13.4116 144.139 12.471C142.994 11.5435 141.35 11.0765 139.245 11.0765H131.826V29.8625H134.424V21.9035H138.219L143.875 29.8625H147L141.12 21.818ZM134.424 19.5026V13.5432H139.219C141.863 13.5432 143.205 14.5298 143.205 16.4834C143.205 18.4896 141.863 19.5026 139.219 19.5026H134.424Z"
      fill="#333333"
    />
    <path
      d="M0 16.0036V30.8956L9.76047 26.0018V11.1032L0 16.0036Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.7087 14.9777L31.709 14.9775L17.0749 0L4.88086 6.12388L19.5149 21.1013L19.5146 21.1014V36L31.7087 29.8761V14.9777Z"
      fill="#333333"
    />
    <path
      d="M14.6354 34.7238L9.76172 33.4477V26.0017L14.6354 27.2712V34.7238Z"
      fill="#333333"
    />
    <path
      d="M0 16.0036V30.8956L9.76047 26.0018V11.1032L0 16.0036Z"
      fill="#333333"
    />
    <path
      d="M31.709 14.9775L19.515 21.1014L4.88086 6.12388L17.0749 0L31.709 14.9775Z"
      fill="#333333"
    />
    <path
      d="M14.6354 34.7238L9.76172 33.4477V26.0017L14.6354 27.2712V34.7238Z"
      fill="#333333"
    />
  </svg>
);

export default HoverLogo;
